import React, { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import { useResume } from '../context/ResumeContext';
import DraftEditor from './common/DraftEditor';
import { ADDITONAL_PREDEFINE_SECTIONS } from '../constants/constants';
import DeleteIcon from '../assets/images-new/icons/bin-icon.svg';
import { usePopup } from '../context/PopupContext';
import { formatDate, rbDate2String, removeBodyScroll } from '../helper';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import DraggableIcon from '../assets/images/draggable-icon.svg';
const Volunteer = (props) => {
  const {
    resume: {
      heading: { fname },
      volunteer,
      enabled_tabs
    },
    handlers: {
      updateResumePreview,
    },
  } = useResume();
  const confirmbox = usePopup();
  let grid = volunteer.hasOwnProperty('grid') ? volunteer.grid : {};
  const emptyrow = ADDITONAL_PREDEFINE_SECTIONS.volunteer.struct.grid.row_1
  const [checkField, setCheckField] = useState('');
  useEffect(() => {
    if (!volunteer.hasOwnProperty('grid')) {
      let struct = { ...emptyrow };
      struct.content = volunteer.content;
      updateResumePreview({ volunteer: { ...volunteer, grid: { row_1: { ...struct } } } });
    }
  }, []);

  const updateRow = (input, id) => {
    const row = {
      [id]: {//example certifications_1
        ...grid[id],
        ...input
      }
    }
    updateResumePreview(
      { volunteer: { ...volunteer, grid: { ...grid, ...row } }, current_tab: 'additional_sections',  }
    )
  }
  const addRow = (newname = '') => {
    const id = 'row_' + Math.floor(Math.random() * 1000)
    const row = { ...emptyrow }
    /**
     * START
     * Changes to close automatically the previously opened tabs on adding a new one
     * Ticket: https://gitlab.dailyrssmail.com/growthlabs/resumebuilder-app/-/issues/530
     * Date: 2024-01-05
     */
    grid = Object.keys(grid).map(key => {
      return {...grid[key], open: false}
    })
    /**
     * END
     */
    updateResumePreview(
      { volunteer: { ...volunteer, grid: { ...grid, [id]: { ...row } } }, current_tab: 'additional_sections',  }
    )
  }
  const deleteRow = (id) => {
    if (grid.hasOwnProperty(id)) {
      let t = { ...grid }
      delete t[id]
      if (!Object.keys(t).length) {//Last need to handle with default settings
        const newid = 'row_' + Math.floor(Math.random() * 1000)
        t = { [newid]: { ...emptyrow } }
      }
      updateResumePreview({ volunteer: { ...volunteer, grid: { ...t } }, current_tab: 'additional_sections' })
    }
  }
  const fieldFocus = (e, id) => {
    setCheckField(e.target.name + '-' + id)
  }
  const fieldBlur = (e, id) => {
    setCheckField('');
  }

  const TabStatus = props => <div className="arrow-action" onClick={props.onClick}> {props.t ? <i className="icon-chevron-left"></i> : <i className="icon-right-arrow"></i>}</div>;
  
  const onDragEnd = result => {
    const { destination, source, draggableId } = result;
    if (!destination) return
    if (destination.droppableId === source.droppableId && destination.index === source.index) return
    const grid1 = {};
    let ids = Object.keys(volunteer.grid), grid = {};
    ids.splice(source.index, 1)
    ids.splice(destination.index, 0, draggableId)
    ids.forEach(element => {
      const id = 'row_' + Math.floor(Math.random() * 1000)
      grid1[id] = { ...volunteer.grid[element] }
      //grid1.push( { ...section.grid[element] })
      })
    updateResumePreview(
      { 
        volunteer: { 
          ...volunteer, 
          grid: {...grid1},
        }, current_tab: 'additional_sections',  }
    )    
  }
  return (<DragDropContext onDragEnd={onDragEnd}>
  <div className="editor-form volunteer-blocks">
  <Droppable droppableId={'unrelavent'}>
    {(provided) => (
    <div 
      ref={provided.innerRef} 
      {...provided.droppableProps}
      >
    {Object.keys(grid).map((id, index) => (
      <Draggable draggableId={id} index={index} key={id}>
          {(provided, snapshot) => (
            <div className="sub-list-wrap" key={id} ref={provided.innerRef} {...provided.draggableProps}>
              <div className="sub-list">
                <div className='addtiaonl-section-reorder'>
                  <div className="reorder">
                          <div type="button" className="btn btn-link" dataid={id} {...provided.dragHandleProps}><DraggableIcon /></div>
                  </div>
                  <span className="sub-name">{grid[id].activity_name.length ? grid[id].activity_name : 'Activity'}</span>
                </div>
                <div className="controls">
                  <div className="delete-action">
                    <span onClick={(e) => {confirmbox.show('row_delete', null, () => deleteRow(id)), removeBodyScroll(true)}}>
                      <DeleteIcon />
                    </span>
                  </div>
                  <TabStatus t={grid[id].open} onClick={() => (updateRow({ open: !grid[id].open }, id))} />
                </div>
              </div>
              {grid[id].open && <div className="sub-form">
                <div className="form-row">

                  <div className="field-wrap">
                    {/* <label htmlFor="activity_name" className={`label${checkField == 'activity_name-' + id ? ' label-focus' : ''}`}>Activity Name</label> */}
                    <input
                      placeholder="Activity Name"
                      type="text"
                      name="activity_name"
                      onChange={(e) => {
                        updateRow({ activity_name: e.target.value }, id)
                        //e.target.value
                      }}
                      value={grid[id].activity_name}
                      onFocus={(e) => fieldFocus(e, id)}
                      onBlur={(e) => fieldBlur(e, id)}
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="field-wrap">
                    {/* <label htmlFor="address" className={`label${checkField == 'address-' + id ? ' label-focus' : ''}`}>Address</label> */}
                    <input
                      placeholder="Address"
                      type="text"
                      name="address"
                      onChange={(e) => {
                        updateRow({ address: e.target.value }, id)
                        //e.target.value
                      }}
                      value={grid[id].address}
                      onFocus={(e) => fieldFocus(e, id)}
                      onBlur={(e) => fieldBlur(e, id)}
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="field-wrap">
                    {/* <label htmlFor="address_line_2" className={`label${checkField == 'address_line_2-' + id ? ' label-focus' : ''}`}>Address Line 2</label> */}
                    <input
                      placeholder="Address Line 2"
                      type="text"
                      name="address_line_2"
                      onChange={(e) => {
                        updateRow({ address_line_2: e.target.value }, id)
                        //e.target.value
                      }}
                      value={grid[id].address_line_2}
                      onFocus={(e) => fieldFocus(e, id)}
                      onBlur={(e) => fieldBlur(e, id)}
                    />
                  </div>
                </div>
                <div className="form-row column-2">
                  <div className="field-wrap date-field">
                    {/* <label htmlFor="start_date" className={`label${checkField == 'start_date-' + id ? ' label-focus' : ''}`}>Start Date</label> */}
                    <DatePicker
                      showMonthYearPicker
                      placeholderText="Start Date"
                      value={formatDate(grid[id].start_date)}
                      selected={formatDate(grid[id].start_date)}
                      name="start_date"
                      //selected={formatDate(education.end_date)}
                      className="form-input borderaccent custom-date-picker"
                      dateFormat="MMMM yyyy"
                      disabled={false}
                      autoComplete="off"
                      onChange={e => updateRow({ start_date: rbDate2String(e.getMonth(), e.getFullYear()) }, id)}
                      onChangeRaw={e => e.preventDefault()}
                      onFocus={(e) => fieldFocus(e, id)}
                      onBlur={(e) => fieldBlur(e, id)}
                    />
                  </div>
                  <div className="field-wrap date-field">
                    {/* <label htmlFor="end_date" className={`label${checkField == 'end_date-' + id ? ' label-focus' : ''}`}>End Date</label> */}
                    <DatePicker
                      showMonthYearPicker
                      placeholderText="End Date"
                      value={formatDate(grid[id].end_date)}
                      selected={formatDate(grid[id].end_date)}
                      name="end_date"
                      className="form-input borderaccent custom-date-picker"
                      dateFormat="MMMM yyyy"
                      disabled={false}
                      autoComplete="off"
                      onChange={e => updateRow({ end_date: rbDate2String(e.getMonth(), e.getFullYear()) }, id)}
                      onChangeRaw={e => e.preventDefault()}
                      onFocus={(e) => fieldFocus(e, id)}
                      onBlur={(e) => fieldBlur(e, id)}
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="field-wrap">
                    <label htmlFor="description" className="label editor-label">Summary</label>
                    <DraftEditor
                      name="description"
                      // placeholder="e.g. Passionate science teacher with 8+ years of experience and a track record of..."
                      className="validate"
                      value={grid[id].content}
                      onInputChange={val => updateRow({ content: val }, id)}
                    />
                  </div>
                </div>
              </div>}
          </div>
          )}
        </Draggable>
    ))}
    {provided.placeholder}
    </div>
    )}
     </Droppable>
    <div className="add-more-wrap">
      <span
        className="add-more-skills"
        onClick={(e) => {
          addRow()
        }}>
        <i className="icon-plus-icon"></i> Add one more
      </span>
    </div>
  </div></DragDropContext>);
}

export default Volunteer;